$(document).ready(function () {

  $('.product-hero-carousel__thumbs button').attr('aria-pressed','false');
  $('.product-hero-carousel__thumbs button.current').attr('aria-pressed','true');
  $('.product-hero-carousel__thumbs button').click(function(){
    $('.product-hero-carousel__thumbs button').attr('aria-pressed','false');
    $(this).attr('aria-pressed','true');
  });

  $('button.site-header__mobile-btn').click(function(){
    $('nav.mobile-nav').attr('aria-hidden','false');
  });
  $('button.mobile-nav-close').click(function(){
    $('nav.mobile-nav').attr('aria-hidden','true');
  });

  $('.back-to-top').click(function(){
    $('.skip-link').focus();
    //$('.skip-link').addClass('ac-focus');
  });

  var width = $(window).width();

  var containerSectionCartSideCart = focusTrap.createFocusTrap("#sidecart", {
    onActivate: () => {
      $("a#close-sidecart").focus();
      $("a#close-sidecart").addClass("ac-focus");
    },
    onDeactivate: () => {
      $("a#close-sidecart").blur();
      $("body").removeClass("sidecart-open");
    },
  });

  //header-cart

  if (width > 767) {
    $(".mobile-nav").attr("aria-hidden", "true");
    $(".footer-signup-mobile .site-footer-signup").attr("id", " ");
    $(".footer-signup-mobile form.contact-form").attr("id", " ");
    $(".footer-signup-mobile .input-group__field").attr("id", " ");
    $(".footer-signup-mobile .newsletter__submit").attr("id", " ");
    $(".mobile-only-sub-menu").attr({
      id: " ",
      style: "display:none!important;",
    });
    $(".mobile-nav .mobile-nav-close").attr("tabindex", "-1");
    $(".mobile-nav .mobile-nav__main-nav a").attr("tabindex", "-1");
    $(".mobile-nav .mobile-nav__utility-nav a").attr("tabindex", "-1");
    $("#r-1535500841672").css("z-index", "2");
    $(".gryffeditor .module-wrap").css("z-index", "2");
  } else {
    $(".footer-signup-desktop .site-footer-signup").attr("id", " ");
    $(".footer-signup-desktop form.contact-form").attr("id", " ");
    $(".footer-signup-desktop .input-group__field").attr("id", " ");
    $(".footer-signup-desktop .newsletter__submit").attr("id", " ");
    $(".module-wrap nav[data-sticky]").attr({
      id: " ",
      style: "display:none!important;",
    });
    $(".site-header__grid ul li a").attr("tabindex", "-1");
    $(".mobile-nav .mobile-nav-close").removeAttr("tabindex");
    $(".mobile-nav .mobile-nav__main-nav a").removeAttr("tabindex");
    $(".mobile-nav .mobile-nav__utility-nav a").removeAttr("tabindex");
    
    $('button.site-header__mobile-btn').click(function(e){
      setTimeout(function(){
         $('.mobile-nav-close').focus();   
      },250)
    }); 

    $('.mobile-nav-close').click(function(e){
         $('.site-header__mobile-btn').focus();
    });

    $(".footer-nav-section").click(function(){
    if($(this).hasClass('expanded')){
        $(this).find('h4').attr('aria-expanded','true');
    }
    else{
        $(this).find('h4').attr('aria-expanded','false');
    }
    });
  }

  $("#interactApp5bcca4ef9fea260013e6cc55").attr("title", "iframe");
  $("#keetsa-and-hotels h3.gf_gs-text-heading-2").attr(
    "aria-label",
    "text-heading"
  );
  $("#terms-amp-conditions .gf_gs-text-heading-2").attr(
    "aria-label",
    "text-heading"
  );
  $("#keetsa-sitemap .gf_gs-text-heading-2").attr("aria-label", "text-heading");
  $("#r-1535922801748 a").attr("aria-label", "site-heading");
  $("#r-1535923606764 a").attr("aria-label", "site-heading");
  $("#r-1535485418078 img").attr("alt", "keetsa image");
  $("#r-1548694543509 img").attr("alt", "keetsa image");

  $(
    '#keetsa-mattress-store-in-los-angeles-thoughtfully-crafted-mattresses a.navigable[target="_blank"]'
  ).attr("aria-label", "Opens in a new tab");
  $("#create-account input#FirstName").attr(
    "aria-label",
    "Enter your first name"
  );
  $("#create-account input#LastName").attr(
    "aria-label",
    "Enter your last name"
  );
  $("#create-account input#Email").attr("aria-label", "Enter your email");
  $("#r-1535500841672 img.gf_hero-fixed").attr(
    "alt",
    "Building, Architecture, Monochrome"
  );
  $("#e-1535573959371 img").attr(
    "alt",
    "affirm financing logo plus Keetsa texture logo"
  );
  $("#m-1544305300538 img").attr(
    "alt",
    "Graphical image of Buying a Mattress, Giving a Smile"
  );
  $("#e-1535665263520 img").attr("alt", "Take your mattress now icon");
  $("#e-1535665263538 img").attr("alt", "0% APR financing icon");
  $("#e-1535665263539 img").attr(
    "alt",
    "Meet our knowledgeable sleep guide icon"
  );

  // place this line in the dialog show function - to only add the listener when the dialog is shown
  //window.addEventListener("keydown", handleKey);

  // uncomment and place this in the dialog close/hide function to remove the listener when dialog is closed/hidden
  // window.removeEventListener('keydown', handleKey);

  function handleKey(e) {
    if (e.keyCode === 9) {
      let focusable = document
        .querySelector(".site-header__cart")
        .querySelectorAll("input,button,select,textarea");
      if (focusable.length) {
        let first = focusable[0];
        let last = focusable[focusable.length - 1];
        let shift = e.shiftKey;
        if (shift) {
          if (e.target === first) {
            // shift-tab pressed on first input in dialog
            last.focus();
            e.preventDefault();
          }
        } else {
          if (e.target === last) {
            // tab pressed on last input in dialog
            first.focus();
            e.preventDefault();
          }
        }
      }

      let focusable_menu = document
        .querySelector(".mobile-nav")
        .querySelectorAll("input,button,select,textarea,a");
        if (focusable_menu.length) {
        let first_ele = focusable_menu[0];
        let last_ele = focusable_menu[focusable_menu.length - 1];
        let shift_key = e.shiftKey;
        if (shift_key) {
          if (e.target === first_ele) {
            // shift-tab pressed on first input in dialog
            last_ele.focus();
            e.preventDefault();
          }
        } else {
          if (e.target === last_ele) {
            // tab pressed on last input in dialog
            first_ele.focus();
            e.preventDefault();
          }
        }
      }
      
    }
  }

  $(document).on("click", "#close-sidecart", function () {
    containerSectionCartSideCart.deactivate();
  });

  $(document).on("click", ".site-header__cart", function () {
    $("body").addClass("sidecart-open");
    containerSectionCartSideCart.activate();
  });

  $(document).on("click", ".add_cart_focus", function () {
    $("body").addClass("sidecart-open");
    containerSectionCartSideCart.activate();
  });

  $(document).mouseup(function(e) {

    if(e.target.id === 'sidecart-overlay'){
      //setTimeout(function() {
         //$("body").removeClass("sidecart-open");
          containerSectionCartSideCart.deactivate();
        //}, 500);  
    }
    
  });

  $(document).on({ 'touchend' : function(e) {
     if(e.target.id === 'sidecart-overlay'){
        //setTimeout(function() {
          //$("body").removeClass("sidecart-open");
          containerSectionCartSideCart.deactivate();
        //}, 500);   
     }
  } 
  });


  $(".site-header__cart").keypress(function (e) {
    if (e.keyCode === 13) {
      $("body").addClass("sidecart-open");
      containerSectionCartSideCart.activate();
    }
  });

  $("#close-sidecart").keypress(function (e) {
    if (e.keyCode === 13) {
      containerSectionCartSideCart.deactivate();
    }
  });

  $("a#close-sidecart").blur(function () {
    $("a#close-sidecart").removeClass("ac-focus");
  });

  // $('.sidecart-overlay').click(function(){
  //   $('body').removeClass("sidecart-open");
  // })
});
